<template>
  <div class="profilewrapper">

      <b-container>
        <h3 class="text-center">Profile</h3>
      </b-container>

      <div class="profilepicWrap">

          <span 
                :style="`background-image : url(${userpic});`"
                class="profileimage">

                 <template v-if="!userpic">
                    <b-icon icon="person-circle"></b-icon>
                </template>

                <span 
                    v-if="isedit"
                    class="uploadpic" 
                    @click="$refs.uploadpic.click()">
                    <b-icon icon="pencil"></b-icon>
                    
                    <input @change="uploadpic" ref="uploadpic" accept="image/*" type="file" style="display:none;">
                </span>
            </span>

          

          
      </div>

      <div class="profilebody">
          <b-container>
              <b-col cols="12" class="text-right">
                  <button 
                    @click="isedit = true"
                    class="btn btn-outline-primary editbtn">Edit</button>
              </b-col>
              <b-row>

                  <b-col md="6">
                      <b-form-group label="First Name">
                          <b-form-input 
                            v-model="user.first_name"
                            placeholder="First Name"
                            :readonly="!isedit" ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col md="6">
                      <b-form-group label="Last Name">
                          <b-form-input
                            v-model="user.last_name"
                            placeholder="Last Name"
                            :readonly="!isedit" ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col md="6">
                      <b-form-group label="Phone">
                          <b-form-input 
                            v-model="user.phone_number"
                            placeholder="Phone"
                            :readonly="!isedit" ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col md="6">
                      <b-form-group label="Email">
                          <b-form-input
                            v-model="user.email"
                            placeholder="Email address"
                            :readonly="true" ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col md="12">
                      <b-form-group label="Street">
                          <b-form-input
                            id="useraddress"
                            v-model="user.address_street"
                            placeholder="Street"
                            :readonly="!isedit" ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col md="4">
                      <b-form-group label="City">
                          <b-form-input 
                            v-model="user.address_city"
                            placeholder="City"
                            :readonly="true" ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col md="4">
                      <b-form-group label="State">
                          <b-form-input
                            v-model="user.address_state"
                            placeholder="State"
                            :readonly="true" ></b-form-input>
                      </b-form-group>
                  </b-col>

                  <b-col md="4">
                      <b-form-group label="Zip Code">
                          <b-form-input 
                            v-model="user.address_zipcode"
                            placeholder="Zip Code"
                            :readonly="true" ></b-form-input>
                      </b-form-group>
                  </b-col>
                  
                  <b-col cols="12" v-if="isedit">
                      <b-btn 
                        @click="updateprofile"
                        block 
                        class="mt-3" 
                        variant="primary">Update</b-btn>

                      <b-btn 
                        @click="$router.push({name : 'changepassword'})"
                        block 
                        class="mt-3" 
                        variant="primary">Change Password</b-btn>

                      <b-btn 
                        @click="isedit = false"
                        block 
                        class="mt-3" 
                        variant="outline-primary">Cancel</b-btn>
                  </b-col>
              </b-row>
          </b-container>
      </div>
  </div>
</template>

<script>
// Mixins
import {mapMixins} from '@/mixins/mapMixins'
import axios from 'axios'
export default {
    mixins : [mapMixins],
    data() {
        return {
            isedit : false,
            avatar : {
                preview: '',
                file   : null
            }
        }
    },
    computed : {
        /**
         * User profile pic
         */
        userpic() {
            if(this.avatar.preview) {
                return this.avatar.preview
            } else if(this.user.avatar_url) {
                return this.user.avatar_url
            }  else {
                return ''
            }
        },
        /**
         * Logged in user profile
         */
        user : {
            get() {
                return this.$store.state.user
            },
            set(user) {
                this.$store.commit('updateuser', user)
            }
        }
    },
    methods : {
        /**
         * Upload profile pic
         */
        uploadpic(e) {
            const [file] = e.target.files

            if(file) {
                this.avatar.preview = URL.createObjectURL(file)
                this.avatar.file    = file
            }
        },
        /**
         * Update profile info
         */
        async updateprofile() {
            this.isedit = false
            const url = `update_user_info/${this.user.id}`

            /**
             * Form data parameters
             */
            let params = new FormData()
            for (const key in this.user) {
                if (Object.hasOwnProperty.call(this.user, key)) {
                    const value = this.user[key];
                    params.append(key, value)

                    /**
                     * Check if hav new avatar file
                     */
                    if(this.avatar.file) {
                        params.append('avatar', this.avatar.file)
                    }

                    /**
                     * Get role
                     */
                    let role = 'driver'

                    if(this.user.roles.includes('super-admin')) {
                        role  = 'super-admin'
                    } else if(this.user.roles.includes('manager')) {
                        role  = 'manager'
                    } else if(this.user.roles.includes('driver')) {
                        role  = 'driver'
                    }

                    params.append('role', role)
                }
            }


            const res = await axios.post(url, params).catch(err => console.log(err))

            if(res.data.success) {
                this.$store.dispatch('getuser')
            }

        },
        /**
         * autocomplete place will query from google map api to get address suggestion.
         * @param {DOM} inputbox input box where the autocomplete will trigger
         */
        autocompleteaddress() {
            const inputbox = document.getElementById('useraddress');
            if(inputbox) {
                /**
                 * Callback
                 * Process return data from autocomplete address
                 */
                const callback = (data) => {
                   this.$nextTick(() => {
                        // /**
                        //  * get latitude and longtitude
                        //  */
                        // this.regform.address_latitude  = data.geometry.location.lat();
                        // this.regform.address_longitude = data.geometry.location.lng();

                        /**
                         * get street, city, state, zipcode
                         */
                        // get street
                        let   user         = this.user
                        const streetnumber = data.address_components.find(d => d.types.includes('street_number'));
                        const street       = data.address_components.find(d => d.types.includes('street'));
                        const route        = data.address_components.find(d => d.types.includes('route'));
                        
                        user.address_street = `${streetnumber ? streetnumber.short_name : ''} ${street ? street.short_name : ''} ${route ? route.long_name : ''}`;
                        
                        // get city
                        const city              = data.address_components.find(d => d.types.includes('locality') || d.types.includes('postal_town'));
                              user.address_city = city.long_name;

                        // get state
                        const state              = data.address_components.find(d => d.types.includes('administrative_area_level_1'));
                              user.address_state = state.short_name;

                        // get postal_code
                        const postalcode           = data.address_components.find(d => d.types.includes('postal_code') || d.types.includes('postal_code_suffix'));
                              user.address_zipcode = postalcode.short_name;

                        this.user  = user
                   });

                }

                this.autocompletedress(inputbox, callback);
            }
        },
    },
    /**
     * Run function after component rendered
     */
    mounted () {
        // initialize address autocomplete
        // Initiate google map 
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
            this.autocompleteaddress();
        });
    }
}
</script>

<style lang="scss">
@import '@/scss/partials/_colors.scss';
@import '@/scss/partials/_mixins.scss';

    .profilewrapper {
        padding-bottom : 30px;

        h3 {
            color      : $primaryColor;
            font-size  : 20px;
            font-weight: 700;
            padding    : 15px;
        }

        .profilebody {
            @include screen-up(sm) {
                padding-left : 30px;
                padding-right: 30px;
            }
        }

        legend {
            font-size  : 12px;
            font-weight: 800;
        }

        .form-control {

            padding-left : 15px;

             &:read-only, &:disabled {
                padding-left : 0;
            }
          
        }

        .profilepicWrap {
            text-align     : center;
            margin-bottom  : 30px;
            display        : flex;
            justify-content: center;
            

            .profileimage {
                color          : $lightgrey2;
                width          : 100px;
                height         : 100px;
                background-size: cover;
                display        : block;
                position       : relative;
                border-radius  : 100%;

                svg {
                    font-size : 90px;
                }
            }

            .uploadpic {
                color    : $primaryColor;
                position : absolute;
                bottom   : 10px;
                right    : -10px;
                cursor   : pointer;

                svg {
                    font-size: 20px;
                }
            }
        }

        .editbtn {
            height      : 30px;
            padding     : 0 15px;
            

            &.btn {
                &.btn-outline-primary {
                    color       : $primaryColor;
                    border-color: $primaryColor;

                    &:hover {
                        color : white;
                    }
                }
            }
        }
    }
</style>